export default {"src":"/_next/static/media/EVM-logo.562fdcd1.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};